import { render, staticRenderFns } from "./WeekGoods.vue?vue&type=template&id=26ac70c2&scoped=true"
import script from "./WeekGoods.vue?vue&type=script&lang=js"
export * from "./WeekGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ac70c2",
  null
  
)

export default component.exports